// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__IMiPp","introSec":"styles_introSec__5sJJ4","ttl1":"styles_ttl1__C3k1v","txt1":"styles_txt1__0kH36"};